export const demandStatusesQueryKeys = {
  all: () => ['/demand-statuses'] as const,
  lists: () => [...demandStatusesQueryKeys.all(), 'list'] as const,
};
